import { getAuthStore } from '@/lib/api/client';

export function pluginOwner(userId) {
  const state = getAuthStore().getState();
  if (!userId || !state.token || state._isSigningOut || state.user?.flags?.isGhost || String(state.user?.id) !== String(userId))
    throw new Error('Your account changed. Open Plugins again.');
  const generation = state._sessionGeneration, token = state.token;
  return { generation, token, current: () => {
    const latest = getAuthStore().getState();
    return !!latest.token && !latest._isSigningOut && !latest.user?.flags?.isGhost &&
      String(latest.user?.id) === String(userId) && latest._sessionGeneration === generation;
  } };
}
